import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FilterSelect } from './filters/filter_select';
import { Filters } from '../../../../constants/filter/filters';
import Translation from '../../../translation/translation';
import LastUsedConfiguratorStore from '../../../../../_flux/stores/last_used_configurator_store';
import RegoLookupStore from '../../../../../_flux/stores/rego_lookup_store';
import VehicleFilterStore from '../../../../../_flux/stores/vehicle_configurator_store';
import CONFIGURATOR_TYPES from '../../../../constants/configurator_types';
import VehicleCatalogFilterOptionsStore from '../../../../../_flux/stores/catalog_filter_options_store/vehicle';

class Vehicle extends Component {
    constructor() {
        super();
        this.state = {
            lastUsedConfiguratorStore: LastUsedConfiguratorStore.getState(),
            regoLookupStore: RegoLookupStore.getState(),
            vehicleConfiguratorStore: VehicleFilterStore.getState(),
            vehicleCatalogFilterOptionsStore: VehicleCatalogFilterOptionsStore.getState(),
        };
    }

    componentDidMount() {
        LastUsedConfiguratorStore.addListener(() => this._getLastUsedConfiguratorStore());
        RegoLookupStore.addListener(() => this._getRegoLookupStore());
        VehicleFilterStore.addListener(() => this._getVehicleConfiguratorStore());
        VehicleCatalogFilterOptionsStore.addListener(() => this._getVehicleFilterOptionsStore());
    }

    componentWillUnmount() {
        LastUsedConfiguratorStore.addListener(() => this._getLastUsedConfiguratorStore());
        RegoLookupStore.addListener(() => this._getRegoLookupStore());
        VehicleFilterStore.addListener(() => this._getVehicleConfiguratorStore());
        VehicleCatalogFilterOptionsStore.addListener(() => this._getVehicleFilterOptionsStore());
    }

    _getVehicleFilterOptionsStore() {
        this.setState({
            vehicleCatalogFilterOptionsStore: VehicleCatalogFilterOptionsStore.getState(),
        });
    }

    _getLastUsedConfiguratorStore() {
        this.setState({
            lastUsedConfiguratorStore: LastUsedConfiguratorStore.getState(),
        });
    }

    _getRegoLookupStore() {
        this.setState({
            regoLookupStore: RegoLookupStore.getState(),
        });
    }

    _getVehicleConfiguratorStore() {
        this.setState({
            vehicleConfiguratorStore: VehicleFilterStore.getState(),
        });
    }

    render() {
        const {
            onVehicleTyreChange,
            onRegoLookupEdit,
            onVehicleSelectorEdit,
            onShowVehicleInfo
        } = this.props;
        const { lastUsedConfiguratorStore, regoLookupStore, vehicleConfiguratorStore, vehicleCatalogFilterOptionsStore } = this.state;
        const lastUsedConfigurator = lastUsedConfiguratorStore.configuratorSource;
        const showVehicleDetail = [CONFIGURATOR_TYPES.VEHICLE_CONFIGURATOR, CONFIGURATOR_TYPES.REGO_LOOKUP].indexOf(lastUsedConfigurator) >= 0;
        let transDisclaimerText = 'catalog-filters-section-note-registration';
        if (CONFIGURATOR_TYPES.VEHICLE_CONFIGURATOR === lastUsedConfigurator) {
            transDisclaimerText = 'catalog-filters-section-note-vehicle';
        }

        let filterValues = [];
        let tyreOptions = [];
        if (true === showVehicleDetail) {
            if ('vehicle_configurator' === lastUsedConfigurator) {
                filterValues = vehicleConfiguratorStore.values;
                tyreOptions = vehicleCatalogFilterOptionsStore.tyres;
            } else {
                filterValues = regoLookupStore.values;
                for (let i = 0; i < regoLookupStore.vehicleData.length; i++) {
                    if (filterValues[Filters.VEHICLE_ID] === regoLookupStore.vehicleData[i][Filters.VEHICLE_ID]) {
                        tyreOptions = regoLookupStore.vehicleData[i][Filters.VEHICLE_TYRES];
                        break;
                    }
                }
            }
        }

        let tyreSizeValues = this.props.tyreSizeValues;
        let currentTyreValue = '';
        for (let i = 0; i < tyreOptions.length; i++) {
            if (tyreOptions[i][0].includes(tyreSizeValues) && tyreSizeValues !== '|0|') {
                currentTyreValue = tyreOptions[i][0];
            }
        }
        const tyreFilterHasValue = '' !== currentTyreValue;
        const headlineText = (lastUsedConfigurator === 'vehicle_configurator') ?
            'catalog-filters-section-headline-tyres' : 'catalog-filters-section-headline-registration';
        const lastUsedConfiguratorAction = (lastUsedConfigurator === 'vehicle_configurator') ?
            onVehicleSelectorEdit : onRegoLookupEdit;
        if (true === showVehicleDetail && filterValues.tyreOptions.length > 0) {
            return (
                <div className="catalog-filter-section-vehicle-text">
                    <p className="catalog-filter-section__vehicle-hint-text">
                        <Translation
                            id={headlineText}
                            translationKey={headlineText}
                        />
                        {
                            lastUsedConfigurator === 'rego_lookup'
                            &&
                            <span id='registrationState'>
                                <strong>
                                    {filterValues[Filters.REGISTRATION].toUpperCase()},
                                    {filterValues[Filters.VEHICLE_STATE].toUpperCase()}
                                </strong>
                            </span>

                        }

                        <span style={{ float: 'right' }}>
                            <a href="#" onClick={lastUsedConfiguratorAction}>
                                <Translation className="edit"
                                    translationKey={'catalog-filters-section-headline-registration-edit'} />
                            </a>
                        </span>

                        <br />
                        {filterValues[Filters.VEHICLE_MAKE]}&nbsp;
                        {filterValues[Filters.VEHICLE_MODEL]}&nbsp;
                        {filterValues[Filters.VEHICLE_ENGINE]},&nbsp;
                        {filterValues[Filters.VEHICLE_CHASSIS]}&nbsp;
                        {filterValues[Filters.VEHICLE_YEAR]}
                    </p>
                    <FilterSelect
                        name={Filters.VEHICLE_TYRES}
                        value={currentTyreValue}
                        options={tyreOptions}
                        labelTranslationKey="catalog-filters-tyre-sizes-select-label"
                        onChange={onVehicleTyreChange}
                        provideAllOption={false}
                        showTooltip={false}
                        highlight={true}
                        provideAllTranslationKey=''
                    />
                    {
                        tyreFilterHasValue &&
                        <p className='catalog-filter-section-vehicle-note'>
                            <Translation
                                translationKey={transDisclaimerText}
                            />&nbsp;
                            <a onClick={onShowVehicleInfo}><Translation translationKey={'rego-lookup-confirmation-layer-double-check-click-here'} /></a>
                        </p>
                    }
                    {
                        !tyreFilterHasValue &&
                        <p className='catalog-filter-section-vehicle-note'>
                            <Translation
                                translationKey={'catalog-filters-section-note-vehicle-tyre-not-match'}
                            />&nbsp;
                        </p>
                    }
                </div>
            );
        } else {
            return '';
        }
    }
}

Vehicle.propTypes = {
    tyreSizeValues: PropTypes.string.isRequired,
    onVehicleTyreChange: PropTypes.func.isRequired,
    onRegoLookupEdit: PropTypes.func.isRequired,
    onVehicleSelectorEdit: PropTypes.func.isRequired,
    onShowVehicleInfo: PropTypes.func.isRequired,
};

export { Vehicle };
